"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateFormula = void 0;
const formula_1 = require("./formula");
/** Checks a formula before it is saved, with messages for its author */
const validateFormula = (formula, { variables, expected = 'number' }) => {
    const compiled = (0, formula_1.getCompiledFormula)(formula);
    if (compiled instanceof formula_1.FormulaCompileError) {
        return { ok: false, reason: 'invalid-formula', message: `Invalid formula: ${compiled.message}` };
    }
    const unknown = compiled.placeholders.filter((name) => !variables.includes(name));
    if (unknown.length) {
        const names = unknown.map((name) => `{${name}}`).join(', ');
        return { ok: false, reason: 'undefined-variables', message: `Formula uses undefined variables: ${names}` };
    }
    // Only a wrong type is checked: other failures with sample values depend on the answers, not the formula
    const samples = Object.fromEntries(compiled.placeholders.map((name) => [name, 1]));
    const result = compiled.evaluate(samples, { expected });
    if (!result.ok && result.reason === 'invalid-type') {
        const type = expected === 'string' ? 'text' : 'a number';
        return { ok: false, reason: 'invalid-type', message: `Formula must return ${type}` };
    }
    return { ok: true };
};
exports.validateFormula = validateFormula;
